import { useState, useRef } from "react";
import { evaluate } from 'mathjs';

import useMount from '../../hooks/useMount';
import LoadingComponent from "../Commons/LoadingComponent";
import AlertModal from "../Commons/AlertModal";
import ConfirmModal from "../Commons/ConfirmModal";
import ConditionDesignerUserVariable from "./ConditionDesignerUserVariable";
import ConditionDesignerVariable from "./ConditionDesignerVariable";

import { getLabel } from "../../tools/Dictionary";

const ConditionDesignerFormula = (props) =>
{

  //Props
  //const IsDesktop = props.IsDesktop;
  const ReadOnly = props.ReadOnly;
  const Condition = props.Condition;
  const OnCloseModal = props.OnCloseModal;
  const Variable = props.Variable;
  const UserVariable = props.UserVariable;
  const OnSaveFormula = props.OnSaveFormula;

  
  //State
  const [formula, setFormula] = useState(Condition && Condition.data ? Condition.data : "");
  const [error] = useState(false);
  const [listVariable] = useState(() =>
  {


    let list = [];

    UserVariable.forEach((u, index) =>
    {

      if (u.componentCode == "TextInput" || u.componentCode == "DropDown")
      {
        console.log(u);
        if (u.componentCode == "DropDown" || (u.componentData && u.componentData.validation.some(v => v === "integer" || v === "number")))
        {



          list.push({
            step: u.step,
            stepTitle: u.stepTitle,
            component: u.component,
            componentName: u.componentName,
            filtered: false
          });

        }


      }

    });

    return list;

  }, [UserVariable]);
  // const [autocomp, setAutoComp] = useState({
  //   display: false,
  //   position: {
  //     x: 0,
  //     y: 0
  //   },
  //   value: "",
  //   option: []
  // });
  const [autoTimer] = useState(null);
  const [loading] = useState(false);
  const [modalUser, setModalUser] = useState(false);
  const [modalVariable, setModalVariable] = useState(false);
  const [alert, setAlert] = useState({
    Title: "",
    Message: "",
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });
  const [confirm] = useState({
    Title: "",
    Message: "",
    Cancel: "",
    onCancel: () => void 0,
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });

  //Ref
  const textAreaRef = useRef(null);
  const mirrorDivRef = useRef(null);


  useMount(() =>
  {
    return () => clearTimeout(autoTimer);
  }, []);

  // const startAutoTimer = (_data, _index) =>
  // {

  //   // S'il y a déjà un timer, on le supprime
  //   if (autoTimer)
  //   {
  //     clearTimeout(autoTimer);
  //   }

  //   // Créer un nouveau timer
  //   const newAutoTimer = setTimeout(() =>
  //   {
  //     // appeler la fonction
  //     getAutoComplete(_data,_index);
  //   }, 100);

  //   // MAJ du timer
  //   setAutoTimer(newAutoTimer);

  // };

  // const getAutoComplete = (_data, _index) => {


  //   let position = updateCaretPosition();

  //   console.log(_data)

  //   const updatedList = listVariable.map(v =>
  //   {
  //     if (v.componentName && v.componentName && _data && !v.componentName.toLowerCase().startsWith(_data.toLowerCase()))
  //     {
  //       return { ...v, filtered: true };
  //     }
  //     return { ...v, filtered: false };
  //   });

  //   setListVariable(updatedList);


  //   setAutoComp(autocomp => ({
  //     ...autocomp,
  //     display: true,
  //     value: _data,
  //     position,
  //     option: updatedList,
  //     index: _index
  //   }));

    

  // };


  const onChangeFormula = (e) => {

    let value = e.target.value;
    



    // const cursorPosition = e.target.selectionStart;
    // const textBeforeCaret = value.substring(0, cursorPosition);
    // const unmatchedIndex = textBeforeCaret.lastIndexOf('{');
    // const closingBraceIndex = textBeforeCaret.lastIndexOf('}');
    

    // if (unmatchedIndex > closingBraceIndex)
    // {
    //   if (autocomp.display)
    //     getAutoComplete(textBeforeCaret.substring(unmatchedIndex + 1), unmatchedIndex);
    //   else
    //     startAutoTimer(textBeforeCaret.substring(unmatchedIndex + 1), unmatchedIndex);
    // }else{
    //   setAutoComp(autocomp => ({
    //     ...autocomp,
    //     display: false,
    //     value: "",
    //     position: {
    //       x:0,
    //       y:0
    //     },
    //     option: listVariable
    //   }));
    //   clearTimeout(autoTimer);
    // }

     setFormula(value)



  }

  // const onBlurFormula = () =>
  // {

  //   setAutoComp(
  //     {
  //       display: false,
  //       value: "",
  //       position: {
  //         x: 0,
  //         y: 0
  //       }
  //     });

  // };


  // const updateCaretPosition = () =>
  // {
  //   const textarea = textAreaRef.current;
  //   const mirrorDiv = mirrorDivRef.current;

  //   // Set mirror div text content and styles
  //   mirrorDiv.textContent = textarea.value.substring(0, textarea.selectionStart);
  //   mirrorDiv.style.visibility = 'hidden';
  //   mirrorDiv.style.position = 'absolute';
  //   mirrorDiv.style.whiteSpace = 'pre-wrap';
  //   mirrorDiv.style.wordWrap = 'break-word';
  //   mirrorDiv.style.width = `${textarea.clientWidth}px`;
  //   mirrorDiv.style.fontFamily = window.getComputedStyle(textarea).fontFamily;
  //   mirrorDiv.style.fontSize = window.getComputedStyle(textarea).fontSize;
  //   mirrorDiv.style.lineHeight = window.getComputedStyle(textarea).lineHeight;
  //   mirrorDiv.style.padding = window.getComputedStyle(textarea).padding;

  //   // Append a span to the mirror div to mark the caret position
  //   const span = document.createElement('span');
  //   span.textContent = '|';
  //   mirrorDiv.appendChild(span);
    
  //   // Insert the mirror div into the DOM
  //   document.body.appendChild(mirrorDiv);

  //   // Get the position of the span
  //   const { offsetLeft, offsetTop } = span;

  //   // Remove the mirror div from the DOM
  //   document.body.removeChild(mirrorDiv);

  //   //console.log('Caret position:', { x: offsetLeft, y: offsetTop });

  //   return {
  //     x: offsetLeft + 5,
  //     y: offsetTop + 15
  //   }
  // };
  



  const onEvaluate = (_test = true) => {

    try{

      let replacedFormula = formula;


      // Regular expression to match strings within {} brackets
      let formulaRegex = /\{([^}]+)\}/g;

      // Array to store matched instances
      let variablesFound = [];

      // Match all instances of strings within {} brackets
      let variable;
      while ((variable = formulaRegex.exec(replacedFormula)) !== null)
      {
        variablesFound.push(variable[1]);
      }   

      let tempVariable = [];
      
      variablesFound.forEach(v => {

        const arrV = v.split(".");

        const stepTitle = arrV[0];
        const componentName = arrV[1];

        let indexVariable = listVariable.findIndex(lv => lv.stepTitle == stepTitle && lv.componentName == componentName);

        if (indexVariable > -1){
          replacedFormula = replacedFormula.split("{" + v + "}").join("1");

          if (!_test){
            if (!tempVariable.some(t => t.component == listVariable[indexVariable].component))
              tempVariable.push({
                component: listVariable[indexVariable].component,
                step: listVariable[indexVariable].step
              });
          }

        }else
          throw new Error();


        

      });


      // Regular expression to match strings within [] brackets
      formulaRegex = /\[([^\]]+)\]/g;

      // Array to store matched instances
      variablesFound = [];

      // Match all instances of strings within [] brackets
      while ((variable = formulaRegex.exec(replacedFormula)) !== null)
      {
        variablesFound.push(variable[1]);
      }

      let tempGlobalVariable = [];

      variablesFound.forEach(v =>
      {

        let indexVariable = Variable.findIndex(lv => lv.name === v);

        if (indexVariable > -1)
        {
          replacedFormula = replacedFormula.split("[" + v + "]").join("1");

          if (!_test)
          {
            if (!tempGlobalVariable.some(t => t === Variable[indexVariable].name))
            {
              tempGlobalVariable.push(Variable[indexVariable].name);
            }
          }

        } else
        {
          throw new Error();
        }
      });

      evaluate(replacedFormula);

      if (_test){
        setAlert({
          Title: getLabel("ConditionDesigner", "formula"),
          Message: getLabel("ConditionDesigner", "Formula is valid."),
          Confirm: getLabel("App", "Ok"),
          onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
          Display: true
        }); 
        return null;
      }else
        return [tempVariable, tempGlobalVariable];


    }catch(err){

      //console.log(err);
      if (!_test) throw err;
      else
        setAlert({
          Title: getLabel("App", "Error"),
          Message: getLabel("ConditionDesigner", "There is an error in the formula"),
          Confirm: getLabel("App", "Ok"),
          onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
          Display: true
        });     



    };



  };


  const onChangeUserVariable = (_index) => {


    try{

      const currentVariable = listVariable[_index];

      setFormula(formula => formula +  "{" + currentVariable.stepTitle + "." + currentVariable.componentName + "}");

      setModalUser(false);


    }catch(err){

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

    }



  };

  const onChangeGlobalVariable = (_id) =>
  {


    try
    {

      const currentVariable = Variable.find(v => v._id == _id);
      
      //Variable[_index];

      setFormula(formula => formula + "[" + currentVariable.name + "]");

      setModalVariable(false);


    } catch (err)
    {

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

    }



  };

  const onConfirm = () => {

    try{

      let [currentVariable] = onEvaluate(false);


      OnSaveFormula(formula, currentVariable);



    }catch(err){

      setAlert({
        Title: getLabel("App", "Error"),
        Message: getLabel("ConditionDesigner", "There is an error in the formula"),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });     

    }



  };


  return (
    <div className="page_modal_background">
      <div className="page_modal_cont" style={{ width: "800px" }}>
        <LoadingComponent
          display={loading}
          label={getLabel("App", "Loading")}
        />
        <AlertModal
          Title={alert.Title}
          Message={alert.Message}
          Confirm={alert.Confirm}
          onConfirm={alert.onConfirm}
          Display={alert.Display}
        /> 
        <ConfirmModal
          Display={confirm.Display}
          Title={confirm.Title}
          Message={confirm.Message}
          Cancel={confirm.Cancel}
          onCancel={confirm.onCancel}
          Confirm={confirm.Confirm}
          onConfirm={confirm.onConfirm}
        /> 
        {modalUser &&
          <ConditionDesignerUserVariable
            UserVariable={listVariable}
            OnClickVariable={onChangeUserVariable}
            OnCloseModal={() => setModalUser(false)}
          />
        }
        {modalVariable &&
          <ConditionDesignerVariable
            Variable={Variable.filter(v => v.variableTypeCode == "int" || v.variableTypeCode == "number")}
            OnClickVariable={onChangeGlobalVariable}
            OnCloseModal={() => setModalVariable(false)}
          />
        }
        <div className="page_modal_header_cont" style={{ marginBottom: "10px" }}>
          {getLabel("ConditionDesigner", "Edit the formula")}
        </div>
        <div className="page_modal_body_cont">
          <div className="page_modal_body_row" >
            <textarea
              ref={textAreaRef}
              className={"page_textarea_input " + (error ? "page_modal_body_col_input_error" : "")}
              style={{width: "100%", zIndex: "80"}}
              rows={3}
              value={formula || ""}
              onChange={(e) => onChangeFormula(e)}
              type="text"
              disabled={ReadOnly || loading}
            />
            <div ref={mirrorDivRef} className="conditiondesigner_mirror" />
          </div>
          <div className="page_modal_body_row" style={{justifyContent: "center"}}>
            <input
              type="button"
              className="page_button page_modal_footer_button"
              value={getLabel("ConditionDesigner", "Add a variable")}
              style={{ maxWidth: "200px" }}
              onClick={() => setModalUser(true)}
              disabled={loading}
            />
          </div>
          <div className="page_modal_body_row" style={{ justifyContent: "center" }}>
            <input
              type="button"
              className="page_button page_modal_footer_button"
              value={getLabel("ConditionDesigner", "Add a global variable")}
              style={{ maxWidth: "200px" }}
              onClick={() => setModalVariable(true)}
              disabled={loading}
            />
          </div>
          <div className="page_modal_body_row" style={{ justifyContent: "center" }}>
            <input
              type="button"
              className="page_button page_modal_footer_button"
              value={getLabel("ConditionDesigner", "Test the formula")}
              style={{ maxWidth: "200px" }}
              onClick={onEvaluate}
              disabled={loading}
            />
          </div>
        </div>
        <div className="page_modal_footer_cont">
          <input
            type="button"
            className="page_button page_modal_footer_button"
            value={getLabel("App", "Close")}
            style={{ backgroundColor: "grey", maxWidth: "200px" }}
            onClick={(loading && !OnCloseModal) ? undefined : OnCloseModal}
            disabled={loading}
          />
          {!ReadOnly &&
            <input
              type="button"
              className="page_button page_modal_footer_button"
              value={getLabel("App", "Confirm")}
              style={{ maxWidth: "200px" }}
              onClick={onConfirm}
              disabled={loading}
            />
          }
        </div>
      </div>
    </div>
  );

};

export default ConditionDesignerFormula